<!--suppress ALL -->
<template>
  <div class="checkout-wrapper">
    <form id="payment-form" ref="form">
      <section class="container-fluid white-box">
        <div class="row">
          <div class="col-md-12">
            <h2>Checkout</h2>
            <p class="sub-text">Please make sure the information is correct.</p>
            <p class="bold">
              {{ fields.first_name }} {{ fields.last_name }} ({{
                fields.email
              }})
            </p>
          </div>
          <!-- Items -->
          <template v-for="(cartItem, index) in cart.items" :key="index">
            <div class="col-sm-12">
              <div class="row justify-content-between">
                <div class="col-7">
                  <p class="mb-0">{{ cartItem.item.name }}</p>
                  <p
                    class="sub-text m-0 pt-0"
                    v-if="cartItem.count > 1 && cartItem.item.price"
                  >
                    {{ formatPrice(cartItem.item.price) }} each
                  </p>
                  <p
                    class="sub-text m-0 pt-0"
                    v-if="
                      cartItem.item.monthly_payment !== 0 && cartItem.count > 1
                    "
                  >
                    {{ monthly(cartItem.item) }}
                  </p>
                </div>
                <div class="col-1">
                  <p>{{ quantity(cartItem) }}</p>
                </div>
                <div class="col-3 subtotal">
                  <p :class="{ bold: cartItem.item.price <= 0 }">
                    {{ formatPrice(priceForItem(cartItem)) }}
                  </p>
                </div>
              </div>
            </div>
          </template>

          <!-- Revi Delivery-->
          <div v-if="deliveryEnabled" class="col-sm-12">
            <div class="row justify-content-between">
              <div class="col-7">
                <p class="mb-0">Revi Delivery</p>
                <p class="sub-text m-0 pt-0">Flat Fee</p>
              </div>
              <div class="col-3 subtotal">
                <p class="bold">Included</p>
              </div>
            </div>
          </div>

          <!-- Total -->
          <div class="col-sm-12 text-right form-group">
            <p class="bold">
              Total: {{ formatPrice(cart.total + cart.monthly) }}
            </p>
          </div>

          <template v-if="paymentEnabled">
            <div
              class="col-sm-12 stripe-or-wrapper text-center d-flex justify-content-between align-items-center"
            >
              <hr />
              <p class="bold">Choose Payment Method</p>
              <hr />
            </div>
            <div class="col-sm-12 payment-method-options text-center">
              <div class="container-fluid container-payment-method">
                <div class="row payment-method-row">
                  <div class="form-check form-check-inline">
                    <input
                      required
                      v-model="paymentMethod"
                      class="form-check-input"
                      type="radio"
                      name="ach"
                      id="payment-ach"
                      value="ACH"
                    />
                    <label
                      class="outer-box ratio-box-1-1 form-check-label"
                      for="payment-ach"
                    >
                      <img src="../assets/payment-ach.svg" />
                    </label>
                    <p>Pay with ACH</p>
                  </div>
                  <div class="form-check form-check-inline mr-0">
                    <input
                      required
                      v-model="paymentMethod"
                      class="form-check-input"
                      type="radio"
                      name="ach"
                      id="payment-card"
                      value="CARD"
                    />
                    <label
                      class="outer-box ratio-box-1-1 form-check-label"
                      for="payment-card"
                    >
                      <img src="../assets/payment-card-50.svg" />
                    </label>
                    <p>Bank card</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- STRIPE Card Input -->
            <template v-if="paymentMethod === 'CARD'">
              <div class="col-sm-12 text-center">
                <div id="payment-element">
                  <!-- A Stripe Element will be inserted here. -->
                </div>
              </div>

              <div class="col-sm-12 text-center mb-3">
                <div id="card-errors" role="alert">
                  <!-- Used to display form errors. -->
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div
              class="col-sm-12 stripe-or-wrapper text-center d-flex justify-content-between align-items-center"
            >
              <hr />
              <p class="bold">No Credit Card Required at this step!</p>
              <hr />
            </div>
          </template>
        </div>
      </section>

      <section class="container-fluid white-box agreement mt-4">
        <div class="row">
          <TermsOfService />
          <div class="col-md-12">
            <ul>
              <li
                v-if="customTermsInit"
                @click="toggleCustomTermForm($event)"
                style="white-space: pre-line"
              >
                <a href="#">Additional Terms:<br />{{ customTermsInit }} </a>
              </li>
            </ul>
            <a
              v-if="!customTermsInit"
              @click="toggleCustomTermForm($event)"
              href="#"
            >
              Click to add additional terms (optional)
            </a>
          </div>
          <template v-if="showCustomTermForm">
            <div class="col-md-12">
              <textarea
                name="specialTerms"
                id="specialTerms"
                class="special-terms"
                rows="3"
                placeholder="Please enter additional terms here (optional)"
                v-model="customTerms"
                :disabled="readonlySignature"
              ></textarea>
            </div>
            <div class="col-md-12 d-flex justify-content-end">
              <button
                class="next-button mt-0"
                type="button"
                name="next"
                @click="customTermsSaveClicked"
              >
                Save
              </button>
            </div>
          </template>
        </div>
        <AgreementText></AgreementText>
        <div class="row d-flex justify-content-between">
          <div class="col-sm-8 form-group">
            <input
              v-model="signature_fullname"
              required
              type="text"
              class="form-control"
              id="city"
              aria-describedby="city"
              placeholder="Sign Full Name"
              :disabled="readonlySignature"
            />
          </div>
          <div class="col-sm-4 form-group">
            <input
              v-model="signature_date"
              required
              type="text"
              class="form-control"
              id="state"
              aria-describedby="state"
              placeholder="Date"
              :disabled="readonlySignature"
            />
          </div>
          <div class="col-md-12 d-flex justify-content-end">
            <button
              class="back-button dark-button"
              type="button"
              @click="$emit('back-clicked')"
              name="next"
            >
              Back
            </button>
            <button
              class="next-button"
              type="button"
              name="next"
              @click="finishClicked"
            >
              Finish
            </button>
          </div>
        </div>
      </section>
    </form>
  </div>
</template>

<script>
import store from "@/store";
import { STRIPE_API_KEY } from "@/constants";
import { signupService } from "@/services/ZdashService";
import { sleep } from "@/helpers";
import AgreementText from "@/components/AgreementText";
import TermsOfService from "@/components/TermsOfService";

// eslint-disable-next-line no-undef
const stripe = Stripe(STRIPE_API_KEY, {
  betas: ["link_default_integration_beta_1"],
});

const PAYMENT_ACH = "ACH";
const PAYMENT_CARD = "CARD";

export default {
  name: "CheckoutPage",
  components: {
    TermsOfService,
    AgreementText,
  },
  props: {
    loading: Function,
    error: Function,
    cart: Object,
    customTermsInit: String,
    paymentEnabled: Boolean,
    readonlySignature: Boolean,
    fields: Object,
  },
  data() {
    return {
      stripeElements: undefined,
      // card it's about Stripe
      agreement: false,
      customTerms: this.customTermsInit,
      paymentMethod: PAYMENT_ACH,
      plaidConfigs: undefined,
      showCustomTermForm: false,
      signature_fullname: this.fields.signature,
      signature_date: this.fields.date_of_signing,
    };
  },
  methods: {
    customTermsSaveClicked() {
      this.$emit("custom-terms", this.customTerms);
      this.showCustomTermForm = false;
    },
    toggleCustomTermForm(event) {
      event.preventDefault();
      this.showCustomTermForm = !this.showCustomTermForm;
    },
    async load() {
      this.loadPlaid();
    },
    async finishClicked() {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.reportValidity();
        return;
      }
      this.loading("Processing you payment, don't close the page...");
      await this._saveSignature();
      if (!this.paymentEnabled) {
        await this._toWaitList();
      } else if (this.paymentMethod === PAYMENT_CARD) {
        await this._finishStripePayment();
      } else if (this.paymentMethod === PAYMENT_ACH) {
        this._finishPlaidPayment();
      }
    },
    _saveSignature() {
      return signupService.update(store.signupId, {
        signature: this.signature_fullname,
        date_of_signing: this.signature_date,
      });
    },
    async _toWaitList() {
      this.loading("Almost done! Generating a customer agreement for you...");
      const result = await signupService.toWaitList(store.signupId);
      if (!result) {
        this.loading(undefined);
        this.error(
          "Something went wrong :( \nPlease try again or contact us success@zyrl.us"
        );
        return;
      }
      // For better UX creating should take a few seconds
      await sleep(2000);
      this.loading(undefined);
      this.$emit("finish-clicked");
    },
    async _finishStripeSuccess() {
      this.loading("Almost done! Creating a new dashboard for you...");
      const result = await signupService.finish(store.signupId);
      if (!result.finished) {
        this.loading(undefined);
        this.error(
          "Something went wrong :( \nPlease try again or contact us success@getrevi.com"
        );
        return;
      }
      // For better UX creating should take a few seconds
      await sleep(2000);
      this.loading(undefined);
      this.$emit("finish-clicked");
    },
    async _finishStripePayment() {
      const confirmURI = this.$router.resolve({
        path: `/signup-and-pay/complete/`,
      }).href;
      const confirmURL = window.location.origin + confirmURI;

      const { error } = await stripe.confirmPayment({
        elements: this.stripeElements,
        confirmParams: {
          return_url: confirmURL,
        },
        redirect: "if_required",
      });
      if (error) {
        this.error(error.message);
        return;
      }

      await this._finishStripeSuccess();
    },
    _finishPlaidPayment() {
      this.loading(undefined);
      // eslint-disable-next-line no-undef
      const linkHandler = Plaid.create(this.plaidConfigs);
      linkHandler.open();
    },
    async _finishPlaidSuccess(publicToken, metadata) {
      this.loading("Almost done! Creating a new dashboard for you...");
      await signupService.payPlaid(store.signupId, {
        public_token: publicToken,
        account_id: metadata.accounts[0].id,
      });
      await sleep(2000);
      this.loading(undefined);
      this.$emit("finish-clicked");
    },
    async mountStripePaymentElements() {
      const stripeClientSecret = store.signup.stripe_client_secret;
      const options = { clientSecret: stripeClientSecret };
      this.stripeElements = stripe.elements(options);
      const paymentElement = this.stripeElements.create("payment", {
        defaultValues: {
          billingDetails: {
            email: store.signup.email,
            name: store.signup.first_name + " " + store.signup.last_name,
            phone: store.signup.phone,
          },
        },
      });
      paymentElement.mount("#payment-element");
    },
    priceForItem(cartItem) {
      const item = cartItem.item;
      if (item.price === 0 && item.monthly_payment === 0) {
        return 0;
      }
      const price = item.price ? item.price : item.monthly_payment;
      return price * cartItem.count;
    },
    formatPrice(price) {
      if (price === 0) {
        return "FREE";
      } else if (price < 0) {
        return "- $" + -price / 100;
      } else {
        return "$" + price / 100;
      }
    },
    monthly(item) {
      return `$${item.monthly_payment / 100}/mo each`;
    },
    quantity(cartItem) {
      return cartItem.count !== 1 ? "x" + cartItem.count : "";
    },
    async loadPlaid() {
      const plaidLinkToken = await signupService.getPlaid(store.signupId);
      this.plaidConfigs = {
        token: plaidLinkToken,
        onLoad: function () {
          // The Link module finished loading.
        },
        onSuccess: this._finishPlaidSuccess,
        onExit: async function (err, metadata) {
          if (err != null) {
            this.error(metadata);
            // The user encountered a Plaid API error
            // prior to exiting.
          }
          // metadata contains information about the institution
          // that the user selected and the most recent
          // API request IDs.
          // Storing this information can be helpful for support.
        },
      };
      // eslint-disable-next-line no-undef
    },
  },
  mounted() {
    this.load();
  },
  created() {},
  computed: {
    stripe_style() {
      return {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      };
    },
    deliveryEnabled() {
      return this.fields.locations.some(
        (location) => location.delivery_enabled
      );
    },
  },
  watch: {
    paymentMethod(value) {
      if (value === PAYMENT_CARD) {
        this.$nextTick().then(this.mountStripePaymentElements);
      }
    },
    fields() {
      this.signature_fullname = this.fields.signature;
      this.signature_date = this.fields.date_of_signing;
    },
  },
};
</script>

<style scoped>
.checkout-wrapper {
  /*margin-bottom: 75px !important;*/
}

button {
  /* margin-left: 24px;
  margin-top: 24px; */
  margin-left: 2.22vh;
  margin-top: 2.22vh;
}

.container-fluid {
  /*margin-top: 75px;*/
}

.form-group {
  margin-bottom: 12px;
}

.subtotal {
  text-align: right;
}

.stripe-cc-wrapper {
}

hr {
  width: 50px;
  border: 1px solid #707070;
}

.stripe-or-wrapper p {
  margin: 16px 22px;
}

.stripe-ach-wrapper {
  /* border: 1px solid #0A1E42; */
  border: 1px solid rgba(10, 30, 66, 0.5);
  /* border-radius: 4px; */
  /* font-size: 16px; */
  height: fit-content;
  /* padding: 16px 16px; */
  /* color: #00000099; */
  color: #0a1e42 !important;

  height: 6vh;
  font-size: 1.146vw;
  /* padding: 16px 20px; */
  padding: 1.5vh 1.8vh;
  /* border-radius: 6px; */
  border-radius: 0.5vh;
  font-size: 1rem;
}

.stripe-ach-wrapper:hover {
  border: 1px solid #eb3e16 !important;
}

.terms-of-service-container {
  padding-top: 30px;
  text-align: center;
}

#card-errors {
  color: #eb3e16;
}

.agreement {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.agreement .row {
  padding: 1.875vw 2.5vw !important;
}

ul {
  padding-left: 20px;
}

input[type="checkbox"] {
  height: initial;
  margin-right: 0.5rem;
}

.special-terms {
  width: 100%;
  height: initial;
}

button {
  /* margin-left: 24px;
  margin-top: 24px; */
  margin-left: 2.22vh;
  margin-top: 2.22vh;
}

.container-fluid {
  /* margin-bottom: 75px; */
}

.container-payment-method {
  margin-top: 16px;
}

.payment-method-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.payment-method-row input[type="radio"] {
  display: none;
}

.payment-method-row .form-check {
  width: 31%;
  margin: 0px;
}

.payment-method-row .form-check:nth-child(1),
.payment-method-row .form-check:nth-child(2) {
  margin-right: 3.5%;
}

.payment-method-row input:checked + label,
.payment-method-row label:hover {
  cursor: pointer;
  box-shadow: 0 0px 3px #ff4f21, 0px 3px 6px #00000029;
}

/* Ratio 1:1  */
.ratio-box-1-1 {
  position: relative;
  width: 100%;
}

.ratio-box-1-1:before {
  content: " ";
  display: block;
  padding-bottom: calc(100% / 1 * 1);
}

.payment-method-row label {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
}

.payment-method-row label img {
  padding: 16px;
  /* height: 100%; */
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.payment-method-row .form-check {
  display: flex;
  flex-direction: column;
}

.payment-method-row .form-check p {
  padding-top: 12px;
}

.payment-method-row .countertop label {
}

.payment-method-row .clamp label {
}

select {
  margin-bottom: 0px;
}

.circle-plus {
  border-radius: 50%;
  background-color: #f6f7fb;
  box-shadow: 0px 4px 5px #00000033;
}

.circle-plus:hover {
  background-color: #ff4f21;
  cursor: pointer;
  /*box-shadow: 0px 4px 5px #00000033;*/
}

.fa-minus {
  margin: 1.7vh;
  color: #bfc4cd;
  font-size: 2.22vh;
}

.fa-plus {
  margin: 1.7vh;
  color: #bfc4cd;
  font-size: 2.22vh;
}

.custom-select {
  width: 5em;
  height: 6vh;
}

.custom-select:focus {
  color: rgb(73, 80, 87);
}

.buttons-right {
  display: flex;
  flex-direction: row;
  width: fit-content;
}

a {
  color: #ff4f21;
}

@media (max-width: 1199.99px) {
  .checkbox-support-text {
    padding-left: 16px;
    max-width: 60%;
  }
}
</style>
